import { client } from '@trello/graphql';
import { asString } from '@trello/browser';
import { clientVersion } from '@trello/config';
import { ModelCache } from 'app/scripts/db/model-cache';
import { featureFlagClient } from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import { rpc } from 'app/scripts/network/rpc';
import type { SocketEventType } from 'app/scripts/network/rpc/rpc.types';
import { importWithRetry } from '@trello/use-lazy-component';
interface SocketEvent {
  eventType: SocketEventType;
  eventTime: string;
  eventData: object | string | null;
  timeSincePageLoadInSeconds: number;
}

const optionalSocketData: {
  eventLog: SocketEvent[];
} = {
  eventLog: [],
};

interface ErrorDetails {
  errorTime: string;
  timeSincePageLoadInSeconds: number;
  error: Pick<ErrorEvent, 'message' | 'filename' | 'lineno' | 'colno'>;
}

const optionalErrorData: {
  log: ErrorDetails[];
} = {
  log: [],
};

export const generateSupportDebugData = () => {
  // Strip the "_events" property from the ModelCache because it contains
  // circular references and can't be stringified.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { _events, ...modelCacheWithoutEvents } = ModelCache as any;

  const supportDebugData = {
    meta: {
      browser: asString,
      features: featureFlagClient.all(),
      version: clientVersion,
      sessionStartTime: new Date(Date.now() - performance.now()).toString(),
      sessionDurationInSeconds: performance.now() / 1000,
      exportTime: new Date().toString(),
    },
    apolloCache: client.cache.extract(),
    modelCache: modelCacheWithoutEvents,
    errors: {
      ...optionalErrorData,
    },
    socket: {
      currentSubscriptions: rpc.currentSubscriptions,
      state:
        rpc.rpcSocket && rpc.rpcSocket.socket
          ? rpc.rpcSocket.socket.state
          : 'unknown',
      ...optionalSocketData,
    },
  };

  importWithRetry(
    () =>
      import(
        /* webpackChunkName: "download-support-debug-data" */ './downloadSupportDebugData'
      ),
  ).then(({ downloadSupportDebugData }) => {
    downloadSupportDebugData(supportDebugData);
  });

  return supportDebugData;
};
